<template>
    <form v-show="isInputFormActive" method="POST">
        <div class="row">
            <div class="col-lg-4 col-md-4 col-12">
                <div class="form-group">
                    <label for="itemname">{{ localizationStore.translate("credit.bureau") }}</label>
                    <select
                        v-model="selectedCreditBureauId"
                        @change="getCreditBureauList(selectedCreditBureauId)"
                        id="creditbureau"
                        name="creditbureau"
                        class="form-control"
                        :class="{'is-invalid' : creditBureauError}"
                        required
                    >
                        <option v-for="creditBureau in creditBureaus" v-bind:value="creditBureau.id">{{ creditBureau.name }}</option>
                    </select>
                    <span v-if="creditBureauError" class="invalid-feedback" role="alert">
                        <strong>Field is Required</strong>
                    </span>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-12">
                <div class="form-group">
                    <label>&nbsp;</label>
                    <br />
                    <button @click="submitForm" type="button" class="btn btn-outline-primary btn-submit"> Dispute Selected Items</button>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-12">
                <!-- search input -->
                <div class="custom-search d-flex justify-content-end">
                    <div class="form-group">
                        <label>&nbsp;</label>
                        <div class="d-flex align-items-center">
                            <label class="mr-1">Search</label>
                            <input
                                v-model="searchTerm"
                                placeholder="Search"
                                type="text"
                                class="d-inline-block form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <vue-good-table
      v-show="isInputFormActive"
      ref="inquiry-table"
      v-on:selected-rows-change="creditorSelectionChanged"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
      :select-options="{
        enabled: true,
        disableSelectInfo: true,
        selectOnCheckboxOnly: true
      }"
    >
        <template #table-row="props">
            <span v-if="props.column.field === 'action'">
                <div class="d-flex align-items-center col-actions">
                    <a class="mr-1 text-primary" data-toggle="tooltip" data-placement="top" title="Individual Dispute">
                        <vue-feather type="send" @click="dispute(props.row.id)"></vue-feather>
                    </a>
                </div>
            </span>
        </template>
    </vue-good-table>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <div class="card-body">
                            <form :action="routes.createLetterRoute" method="post" enctype="multipart/form-data" class="row">
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="text" class="form-control" id="creditbureau" name="creditbureau" :value="selectedCreditBureauId" hidden>
                                <div class="col-md-6 pl-md-0 pr-md-3">
                                    <div id="editor">
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="1">
                                            {{ localizationStore.translate("letter.left.submit.button.text") }}
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-6 pl-md-3 pr-md-0 mt-3 mt-md-0">
                                    <div class="arrow-btn">
                                        <button
                                            class="btn btn-outline-primary px-50"
                                            @click="$refs.spinner.spinLetter()"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.letter.button.text") }}
                                            <i data-feather="arrow-right"></i>
                                        </button>
                                    </div>
                                    <div id="editor-right">
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="2">
                                            {{ localizationStore.translate("letter.right.submit.button.text") }}
                                        </button>
                                    </div>
                                </div>
                                <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRef' />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div ref="editorRefSingle" hidden>
            <div class="page">
                <p>
                    {{ userInfo.firstname }} {{ userInfo.lastname }}
                    <br />
                    {{ userInfo.address }}
                    <br />
                    {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                    <br />
                    <br />
                    {{ userInfo.dob }}
                    <br />
                    {{ userInfo.ssn }}
                    <br />
                    <br /> {{ selectedCreditBureau.address_name }}
                    <br /> {{ selectedCreditBureau.street_address }}
                    <br /> {{ selectedCreditBureau.city }}, {{ selectedCreditBureau.state_abbrev }} {{ selectedCreditBureau.zipcode }}
                    <br />
                    <br /> Date: {{ date }}
                </p>
                <p class="letter-content">
                    RE: You Violated the United States Code Law 15 U.S.C. § 1681i (6) Notice of Results of Reinvestigation. I demand you to comply.
                </p>
                <p class="letter-content">
                    After pulling a copy of my Consumer credit report I noticed that your agency is in multiple violations and I’m entitled to monetary compensation under FCRA <strong>15 U.S.C. § 1681i</strong> (6) Notice of Results of Reinvestigation.
                </p>
                <p class="letter-content">
                    (A) In general. A consumer reporting agency shall provide written notice to a consumer of the results of a reinvestigation under this subsection not later than 5 business days after the completion of the reinvestigation, by mail or, if authorized by the consumer for that purpose, by other means available to the agency (B) Contents. As part of, or in addition to, the notice under subparagraph (A), a consumer reporting agency shall provide to a consumer in writing before the expiration of the 5-day period referred to in subparagraph (A)(I) a statement that the reinvestigation is completed.
                </p>
                <p class="letter-content">
                    The items below should all be removed from my consumer report under 15 US Code 1681i (6) as it has been over 45 days and you failed to comply.
                </p>
                <p v-if="selectedCreditor.length > 0">
                    <strong>NAME OF ACCOUNT:</strong> {{ selectedCreditor[0].furnisher_name }}
                    <br />
                    <template v-if="selectedCreditor[0].reference_number">
                        <strong>REFERENCE NUMBER: </strong>{{ selectedCreditor[0].reference_number }}<br />
                    </template>
                    <template v-else>
                        <strong>ACCOUNT NUMBER: </strong>{{ selectedCreditor[0].account_number }}<br>
                    </template>
                </p>
                <p class="letter-content">
                    under 15 US Code 1681n(b) civil liability of a natural person I’ve been violated. Also, we already involved and sent this letter to the Complaint portal for <strong>(Consumer Financial Protection Bureau, State Attorney General’s Office, Better Business Bureau, and Federal Trade Commission).</strong>
                </p>
                <p style="page-break-after: always;">
                    Sincerely, 
                    <br />
                    <br />
                    {{ userInfo.firstname }} {{ userInfo.lastname }}
                </p>
            </div>
        </div>
        <div ref="editorRefMultiple" hidden>
            <div class="page">
                <p>
                    {{ userInfo.firstname }} {{ userInfo.lastname }}
                    <br />
                    {{ userInfo.address }}
                    <br />
                    {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                    <br />
                    <br />
                    {{ userInfo.dob }}
                    <br />
                    {{ userInfo.ssn }}
                    <br />
                    <br /> {{ selectedCreditBureau.address_name }}
                    <br /> {{ selectedCreditBureau.street_address }}
                    <br /> {{ selectedCreditBureau.city }}, {{ selectedCreditBureau.state_abbrev }} {{ selectedCreditBureau.zipcode }}
                    <br />
                    <br /> Date: {{ date }}
                </p>
                <p class="letter-content">
                    RE: You Violated the United States Code Law 15 U.S.C. § 1681i (6) Notice of Results of Reinvestigation. I demand you to comply.
                </p>
                <p class="letter-content">
                    After pulling a copy of my Consumer credit report I noticed that your agency is in multiple violations and I’m entitled to monetary compensation under FCRA <strong>15 U.S.C. § 1681i</strong> (6) Notice of Results of Reinvestigation.
                </p>
                <p class="letter-content">
                    (A) In general. A consumer reporting agency shall provide written notice to a consumer of the results of a reinvestigation under this subsection not later than 5 business days after the completion of the reinvestigation, by mail or, if authorized by the consumer for that purpose, by other means available to the agency (B) Contents. As part of, or in addition to, the notice under subparagraph (A), a consumer reporting agency shall provide to a consumer in writing before the expiration of the 5-day period referred to in subparagraph (A)(I) a statement that the reinvestigation is completed.
                </p>
                <p class="letter-content">
                    The items below should all be removed from my consumer report under 15 US Code 1681i (6) as it has been over 45 days and you failed to comply.
                </p>
                <template v-for="creditor in selectedCreditor">
                    <strong>NAME OF ACCOUNT:</strong> {{ creditor.furnisher_name }}
                    <br />
                    <template v-if="creditor.reference_number">
                        <strong>REFERENCE NUMBER: </strong>{{ creditor.reference_number }}
                        <br />
                    </template>
                    <template v-else>
                        <strong>ACCOUNT NUMBER: </strong>{{ creditor.account_number }}
                        <br />
                    </template>
                    <br />
                </template>
                <p class="letter-content">
                    under 15 US Code 1681n(b) civil liability of a natural person I’ve been violated. Also, we already involved and sent this letter to the Complaint portal for <strong>(Consumer Financial Protection Bureau, State Attorney General’s Office, Better Business Bureau, and Federal Trade Commission).</strong>
                </p>
                <p style="page-break-after: always;">
                    Sincerely, 
                    <br />
                    <br />
                    {{ userInfo.firstname }} {{ userInfo.lastname }}
                </p>
            </div>
        </div>
    </section>
</template>
<script>
  import { reactive, computed, ref } from 'vue'
  import 'vue-good-table-next/dist/vue-good-table-next.css'
  import { VueGoodTable } from 'vue-good-table-next';
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  export default {
    props: {
        csrf: {
            type: String
        },
        propCreditBureaus: {
            type: [Array, Object]
        },
        userInfo: {
            type: [Array, Object]
        },
    },
    components: {
        VueGoodTable,
    },
    setup(props) {
        return {
            creditBureaus: props.propCreditBureaus,
            selectedCreditBureauId: ref(props.propCreditBureaus[0].id),
            editorRefSingle: ref(null),
            editorRefMultiple: ref(null),
            isInputFormActive: ref(true),
            creditBureauError: ref(false),
            date: ref(null),
            editorRef: ref(null),
            localizationStore: useLocalizationStore()
        };
    },
    data(){
        const selectedCreditor = reactive([]);
        return {
          columns: [
            {
              label: 'CREDITOR',
              field: 'furnisher_name',
            },
            {
              label: 'ACCOUNT NUMBER',
              field: 'account_number',
            },
            {
              label: 'PAYMENT STATUS',
              field: 'payment_status',
            },
            {
              label: 'Action',
              field: 'action',
            }
          ],
          rows: [],
          searchTerm: '',
          selectedCreditor
        };
    },
    created() {
        // console.log(this.creditBureaus);
    },
    mounted() {
        axios.get(this.routes.currentDate).then(response => (this.date = response.data));
        this.getCreditBureauList(this.selectedCreditBureauId);
    },
    computed: {
        // a computed getter
        selectedCreditBureau() {
            return this.creditBureaus.find((attribute) => {
                if (attribute.id == this.selectedCreditBureauId) {
                    return attribute;
                }
            })
        },
        isCreditBureauSelected() {
            return (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") ? false : true;
        }
    },
    methods: {
      submitForm: function () {
        if (this.validate()) {
            this.editorRef = this.editorRefMultiple;
            this.selectedCreditor = this.$refs['inquiry-table'].selectedRows;
            tinymce.get('editor').setContent(this.editorRefMultiple.innerHTML);
            this.isInputFormActive = !this.isInputFormActive;
        }
      },
      dispute: function (id) {
        this.selectedCreditor[0] = this.rows.find((attribute) => {
            if (attribute.id == id) {
                return attribute;
            }
        });
        this.editorRef = this.editorRefSingle;
        setTimeout(() => {
            tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
            this.isInputFormActive = !this.isInputFormActive;
        }, "100");
      },
      goBack: function () {
        this.isInputFormActive = !this.isInputFormActive;
      },
      validate: function () {
        if (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") {
            this.creditBureauError = true;
        }
        else {
            this.creditBureauError = false;
        }
        return !this.creditBureauError;
      },
      getCreditBureauList: function (type) {
        axios.get(this.routes.listCreditBureau.replace(':type', type)).then(response => {
                this.rows = response.data.data
            }
        );
      },
      creditorSelectionChanged: function (params) {
        this.selectedCreditor = params.selectedRows;
      }
    }
  };
</script>